(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    

  class RelativeHeader extends HTMLElement {
    constructor() {
      super();

      this.header = this;
     // this.hamburgerButton = this.querySelector(".site-header__hamburger");
      this.dropdowns = this.querySelectorAll("details.site-header__label");
      this.setupListener();
    }

    //Add a on click listener to every dropdown button
    setupListener() {
      this.dropdowns.forEach((dropdown) => {
        dropdown.querySelector("summary").addEventListener('click', this.updateActiveDialog.bind(this));
      });
    //  this.hamburgerButton.addEventListener('click', this.updateActiveDialog.bind(this));
    }

    updateActiveDialog(e) {
      let thisDropdown = e.target.parentNode;
      
      //close all other dropdowns
      this.dropdowns.forEach((dropdown) => {
        if ( dropdown != thisDropdown ){
          dropdown.removeAttribute("open");
        }
      })

      //let the header know a dropdown is open
      //if statement is kind of confusing but its whether the element had the open attr at the time of click
      if ( thisDropdown.hasAttribute("open") ) {
        if(!thisDropdown.classList.contains('__scroll')){
          document.body.classList.remove('__mobile-overflow-none');
        }
        this.header.classList.remove('__dropdown-open');
      } else {
          if(!thisDropdown.classList.contains('__scroll')){
            document.body.classList.add('__mobile-overflow-none');
          }

        this.header.classList.add('__dropdown-open');
      }
    }
  }

  customElements.define('relative-header', RelativeHeader);

  class StickyHeader extends RelativeHeader {
    constructor() {
      super();

      document.addEventListener('scroll', this.updateClass.bind(this), false);
      document.lastScollPosition = 0;
    }

    updateClass(e) {

      let scrollPosition = window.pageYOffset;
      let lastScollPosition = e.currentTarget.lastScollPosition;
      let alwaysShowNav = this.classList.contains('__always-show-nav');
      let scrollingDown = false;
      if (lastScollPosition < scrollPosition) {
        scrollingDown = true;
      }

      if ((!scrollingDown && scrollPosition > 200) || (scrollingDown && scrollPosition > 75 && alwaysShowNav)) {
        this.classList.add('__visible');
        this.parentNode.classList.add('__visible-nav');
        document.querySelectorAll(".__style-relative .disclosure").forEach((details) => {
          const summary = details.querySelector("summary");
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
        })
      } else {
        this.classList.remove('__visible');
        this.parentNode.classList.remove('__visible-nav');   
        document.querySelectorAll(".__style-on-scroll .disclosure").forEach((details) => {
          const summary = details.querySelector("summary");
          details.removeAttribute("open");
          summary.setAttribute("aria-expanded", "false");
          })    
        }

      document.lastScollPosition = scrollPosition;
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
      })();
